import React, { useContext, useState, useEffect } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./css/style.css";
import "./css/responsive.css";
 
import s3 from "./images/s3.png";
import s4 from "./images/s4.png";
import s5 from "./images/s5.png";
import s6 from "./images/s6.png";
import ahorro from "./images/ahorros.png";
import prestamo from "./images/prestamo.png";
import documento from "./images/documento.png";
import hombre from "./images/hombre.png";
import Lottie from "react-lottie-player";
import animation from "./images/animation.json";
import animation2 from "./images/animation2.json";
import animation3 from "./images/animation3.json";
import digital from "./images/Globe.json";
import mouseAnimation from "./images/MouseScroll.json";
import LogoDigital from "./images/2Digital.png";
import injupemplogogobierno from "./images/injupemplogogobierno.png";
import { Link } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import { Modal, Button, Form, Spinner } from "react-bootstrap"; // Importa los componentes necesarios de react-bootstrap
import { Alert, AlertTitle } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Escudo from "../Login/assets/LogoBlanco.png";
import CircularProgress from "@mui/material/CircularProgress"; // Importa el CircularProgress de Material-UI
import { useNavigate, useLocation } from "react-router-dom";
import { ContextSession } from "../../services/ContextSession";
import { FaWhatsapp } from "react-icons/fa"; // Librería para íconos
import Tooltip from "@mui/material/Tooltip";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Grid,
  Divider,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import constancia from "../../components/constancia.png";
import preanalisisFoto from "../../components/hipotecario.png";
import chatbotfoto from "../../components/chatbot.png";
import feVida from "../img/logoFeDeVida.png";
import logoSeparador from "../img/logoseparador.png";
import googleIMG from "../img/google.png";
import appleIMG from "../img/apple.png";

const PaginaInicioPortal = () => {
  let sessi = useContext(ContextSession);
  const isMobile = useMediaQuery("(max-width:450px)"); // Detectar si es una pantalla móvil
  const isMobile2 = useMediaQuery("(max-width:991px)"); // Detectar si es una pantalla móvil
  const [showModal, setShowModal] = useState(false);
  const [showModalCodigo, setShowModalCodigo] = useState(false);
  const [showResultModal, setShowResultModal] = useState(false);
  const [resultMessage, setResultMessage] = useState("");
  const [resultType, setResultType] = useState("success"); // 'success' or 'error'
  const [dni, setDni] = useState("");
  const [correo, setCorreo] = useState("");
  const [loading, setLoading] = useState(false); // Nuevo estado para manejar la carga
  const [verificationCode, setVerificationCode] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const location = useLocation(); // Hook para detectar la ubicación actual
  const [open, setOpen] = useState(true);

  useEffect(() => {
    localStorage.clear();
    sessionStorage.clear();
  }, []);

  const handleCloseAviso = () => {
    setOpen(false);
  };

  useEffect(
    () => {
      // Crear el elemento <link> para el CSS de Bootstrap
      const bootstrapCss = document.createElement("link");
      bootstrapCss.rel = "stylesheet";
      bootstrapCss.href =
        "https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css";
      document.head.appendChild(bootstrapCss);

      // Crear el elemento <script> para jQuery (sin async)
      const jqueryScript = document.createElement("script");
      jqueryScript.src = "https://code.jquery.com/jquery-3.5.1.min.js";
      document.body.appendChild(jqueryScript);

      // Crear el elemento <script> para Popper.js
      const popperScript = document.createElement("script");
      popperScript.src =
        "https://cdn.jsdelivr.net/npm/@popperjs/core@2.5.4/dist/umd/popper.min.js";
      popperScript.async = true;
      document.body.appendChild(popperScript);

      // Crear el elemento <script> para el JS de Bootstrap
      const bootstrapScript = document.createElement("script");
      bootstrapScript.src =
        "https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/js/bootstrap.min.js";
      jqueryScript.onload = () => {
        document.body.appendChild(bootstrapScript);
      };

      // Limpieza de los scripts y estilos cuando se navegue a /Login
      /*if (location.pathname === '/Login') {
            document.head.removeChild(bootstrapCss);
            document.body.removeChild(jqueryScript);
            document.body.removeChild(popperScript);
            if (document.body.contains(bootstrapScript)) {
                document.body.removeChild(bootstrapScript);
            }
        }*/

      // Cleanup al desmontar el componente
      return () => {
        // Limpia los elementos cuando el componente se desmonte
        /*document.head.removeChild(bootstrapCss);
            document.body.removeChild(jqueryScript);
            document.body.removeChild(popperScript);
            if (document.body.contains(bootstrapScript)) {
                document.body.removeChild(bootstrapScript);
            }*/
      };
    },
    [
      /*location.pathname*/
    ]
  ); // Se ejecuta cuando la ruta cambia

  const handleClose = () => {
    setShowModal(false);
    setShowResultModal(false);
    setDni(""); // Limpiar el campo DNI
    setCorreo(""); // Limpiar el campo Correo
    setErrorMessage2(""); // Limpiar el mensaje de error al cerrar el Modal
  };

  const handleCloseCodigo = () => {
    setShowModalCodigo(false);
    setShowResultModal(false);
  };

  const handleShow = () => setShowModal(true);

  const handleShowCodigo = () => {
    setShowModal(false);
    setShowModalCodigo(true);
  };

  const [errorMessage2, setErrorMessage2] = useState("");
  const [showChangeEmailButton, setShowChangeEmailButton] = useState(false); // Inicialmente será false
  const normalizeText = (text = "") =>
    text
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();

  const formatDni = (value = "") => {
    const digits = value.replace(/\D/g, "").slice(0, 13);
    const p1 = digits.slice(0, 4);
    const p2 = digits.slice(4, 8);
    const p3 = digits.slice(8, 13);
    if (digits.length <= 4) return p1;
    if (digits.length <= 8) return `${p1}-${p2}`;
    return `${p1}-${p2}-${p3}`;
  };

  const handleVerify = async (event) => {
    event.preventDefault();
    setLoading(true); // Mostrar el CircularProgress
    setErrorMessage(""); // Reiniciar el mensaje de error
    setShowChangeEmailButton(false);
    sessi.setVariable("CodigoContrato", null);
    const dniDigits = dni.replace(/\D/g, "");

    // Validaciones
    if (dniDigits.length !== 13) {
      setErrorMessage2("El número de identidad debe tener 13 dígitos.");
      setLoading(false);
      return;
    }

    // Validación simple de correo
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(correo)) {
      setErrorMessage2("El correo electrónico no tiene un formato válido.");
      setLoading(false);
      return;
    }

    // Si pasa las validaciones, continúa con la solicitud a la API
    const formData = new FormData();
    formData.append("dni", dniDigits);
    formData.append("correo", correo);

    try {
      const response = await fetch(`${sessi.ip}/api/biometriaverificacion/`, {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        setErrorMessage2(""); // Limpiar el mensaje de error al cerrar el Modal
        setShowChangeEmailButton(false);
        handleShowCodigo();
      } else if (response.status === 404) {
        setErrorMessage2(""); // Limpiar el mensaje de error al cerrar el Modal
        const errorData = await response.json();
        setResultType("error");
        const backendMessage = errorData?.error || "Ocurrió un error inesperado.";
        const normalizedMessage = normalizeText(backendMessage);
        const hasExistingUser = normalizedMessage.includes(
          "ya existe usuario con el dni proporcionado"
        );
        const hasNoDniInfo =
          normalizedMessage.includes("no se encontro informacion") &&
          normalizedMessage.includes("dni proporcionado");

        if (hasExistingUser) {
          setResultMessage(backendMessage);
          setShowChangeEmailButton(false);
        } else if (hasNoDniInfo) {
          setResultMessage(
            `${backendMessage}. Presentarse a la Oficina de INJUPEMP más cercana para realizar el proceso de afiliación.`
          );
          setShowChangeEmailButton(false);
        } else {
          setResultMessage(
            `${backendMessage}. Si ha cambiado de correo, por favor, acuda a la Oficina de INJUPEMP más cercana para actualizar sus datos.`
          );
          setShowChangeEmailButton(true); // Mostrar el botón "Solicitar Cambio De Correo"
        }
      } else {
        setResultType("error");
        setResultMessage("Ocurrió un error inesperado.");
        setShowChangeEmailButton(false); // No mostrar el botón
      }
    } catch (error) {
      setResultType("error");
      setErrorMessage("Error de conexión a internet.");
      setShowChangeEmailButton(false); // No mostrar el botón
    }

    setLoading(false); // Ocultar el CircularProgress
    setShowResultModal(true);
  };

  const { setCanAccessUpdateEmail } = useContext(ContextSession);

  const handleChangeEmailClick = () => {
    // Cambiar el estado a verdadero para permitir el acceso a la ruta
    setCanAccessUpdateEmail(true);
    navigate("/ActualizarCorreo");
  };

  const handleContrato = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage("");
    const dniDigits = dni.replace(/\D/g, "");

    const formData = new FormData();
    formData.append("dni", dniDigits);
    formData.append("codigo", verificationCode);

    try {
      const response = await fetch(`${sessi.ip}/api/codigo/contrato/`, {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        // Navega hacia /Contrato y pasa los datos como estado
        sessi.setVariable("codigoContrato", verificationCode);
        navigate("/Contrato", {
          state: {
            nombre: data.NombreCompleto,
            email: data.email,
            dni: data.dni,
            codigo: data.codigo,
          },
        });
      } else {
        const errorData = await response.json();
        const errorMessage =
          errorData.error === "Código no encontrado."
            ? "El código ingresado es incorrecto"
            : errorData.error || "Ocurrió un error inesperado.";

        setErrorMessage(errorMessage);
      }
    } catch (error) {
      //setErrorMessage('Ocurrió un error en la conexión con la API.');
      setErrorMessage("Error de conexión a internet.");
    } finally {
      setLoading(false);
    }
  };

  const [timeLeft, setTimeLeft] = useState(900); // 900 segundos = 15 minutos

  // Reiniciar el contador cuando el modal se abra
  useEffect(() => {
    if (showModalCodigo) {
      setTimeLeft(900); // Reinicia el contador a 15 minutos cuando se abre el modal
    }
  }, [showModalCodigo]);

  // Actualiza el contador cada segundo
  useEffect(() => {
    let timerId;
    if (timeLeft > 0 && showModalCodigo) {
      timerId = setInterval(() => {
        setTimeLeft((prevTimeLeft) => prevTimeLeft - 1);
      }, 1000);
    }

    return () => clearInterval(timerId); // Limpia el intervalo al cerrar el modal o cambiar el estado
  }, [timeLeft, showModalCodigo]);

  const handleSobrevivencia = () => {
    window.open(
      "https://sobrevivencia.injupemp.gob.hn/",
      "_blank",
      "noopener,noreferrer"
    );
  };

  // Formato del tiempo en MM:SS
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  };

  return (
    <>
      {/*<Dialog open={open} onClose={handleCloseAviso} maxWidth="md" fullWidth>
                <DialogTitle>
                    <Typography variant="h6" textAlign="center">
                        ¡Nuevas Funcionalidades Disponibles!
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={handleCloseAviso}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2} sx={{ height: '100%', justifyContent: 'space-between' }}>
                        <Grid item xs={12} sm={3} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                            <img src={chatbotfoto} alt="ChatBot INJUPEMP Virtual" style={{ width: !isMobile ? '80%' : '50%', borderRadius: '8px' }} />
                            <Typography variant="h6" gutterBottom sx={{ marginTop: 2 }}>
                                Consultas En ChatBot INJUPEMP Virtual
                            </Typography>
                            <Typography textAlign="justify">
                                Ahora puedes realizar tus consultas por medio de WhatsApp en nuestro nuevo ChatBot INJUPEMP Virtual{' '}
                                <Link to={'https://wa.link/kbcxjr'} color="primary" target="_blank" style={{ textDecoration: 'underline' }}>
                                    Pulsando Aquí
                                </Link>
                                {' '}o escribiendo al whatsapp <strong>+504 8984-7191</strong>.
                            </Typography>
                        </Grid>

                        <Grid item xs={12} sm={3} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                            <img src={cotizacionesImagen} alt="Cotizaciones" style={{ width: !isMobile ? '80%' : '50%', borderRadius: '8px' }} />
                            <Typography variant="h6" gutterBottom sx={{ marginTop: 2 }}>
                                Visualizar Saldo de Cotizaciones
                            </Typography>
                            <Typography textAlign="justify">
                                Consulta tu saldo cotizado, el promedio de tus salarios, una estimación de tu pensión y el historial de tus últimos salarios sin complicaciones desde nuestro portal en línea.
                            </Typography>
                        </Grid>

                        <Grid item xs={12} sm={3} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                            <img src={constancia} alt="Descargar constancia de pensionado" style={{ width: !isMobile ? '80%' : '50%', borderRadius: '8px' }} />
                            <Typography variant="h6" gutterBottom sx={{ marginTop: 2 }}>
                                Constancia de Pensionado/Jubilado
                            </Typography>
                            <Typography textAlign="justify">
                                Sin la necesidad de trasladarte a nuestras oficinas, obtén tu constancia de pensionado de manera rápida y sencilla desde nuestro portal en línea en tan solo un clic.
                            </Typography>
                        </Grid>

                        <Grid item xs={12} sm={3} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                            <img src={preanalisisFoto} alt="Solicitud de preanálisis de préstamo hipotecario" style={{ width: !isMobile ? '80%' : '50%', borderRadius: '8px' }} />
                            <Typography variant="h6" gutterBottom sx={{ marginTop: 2 }}>
                                Preanálisis de Préstamo Hipotecario
                            </Typography>
                            <Typography textAlign="justify">
                                Descubre tu monto a otorgar al solicitar un preanálisis para préstamos hipotecarios completando el formulario y adjuntando los documentos requeridos.
                            </Typography>
                        </Grid>
                    </Grid>

                </DialogContent>
                <DialogActions
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Button
                        onClick={handleCloseAviso}
                        style={{
                            border: 'none',
                            backgroundColor: '#AD8401',
                            color: 'white',
                            borderRadius: '12px',
                            '&:hover': {
                                backgroundColor: 'darkred',
                            },
                        }}
                    >
                        Cerrar
                    </Button>
                </DialogActions>
            </Dialog>
            */}

      {/* <Dialog open={open} onClose={handleCloseAviso} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Typography variant="h6" textAlign="center">
            Realiza Ya Tu Prueba de Sobrevivencia 2025
          </Typography>
        </DialogTitle>

        <DialogContent dividers>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 1,
              alignItems: "center",
              backgroundColor: "#89CFE0",
              borderRadius: 3,
              padding: 2,
              flexWrap: "wrap",
            }}
          >
            <img
              src={feVida}
              alt="Fe de Vida"
              style={{ width: !isMobile ? "150px" : "70px" }}
            />
            <img
              src={logoSeparador}
              alt="Separador"
              style={{ width: !isMobile ? "200px" : "100px" }}
            />
          </Box>

          <Typography mt={2} textAlign="justify">
            En cumplimiento del artículo 77 de la Ley de INJUPEMP, se realizará
            la prueba de Sobrevivencia y Reevaluación de Invalidez 2025, a
            jubilados y pensionados a partir del 1 de julio hasta el 5 de
            septiembre del 2025 por medio de nuestra plataforma web.{" "}
            <Link
              component="button"
              variant="body1"
              underline="always" // <--- esto asegura el subrayado siempre
              sx={{ color: "#0077cc", fontWeight: "bold", cursor: "pointer" }}
              onClick={handleSobrevivencia}
            >
              Pulsa aquí para iniciar.
            </Link>
          </Typography>

          {/*<Typography mt={!isMobile ? 2 : 1} textAlign="center" fontWeight="bold">
                        Descárgala ya:
                    </Typography>

                    <Box
                        mt={!isMobile ? 2 : 1}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        gap={!isMobile ? 4 : 2}
                    >
                        <a
                            href="https://play.google.com/store/games?hl=en"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={googleIMG}
                                alt="Google Play"
                                style={{
                                    width: !isMobile ? '180px' : '110px',
                                    height: 'auto',
                                    cursor: 'pointer',
                                }}
                            />
                        </a>
                        <a
                            href="https://www.apple.com/app-store/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={appleIMG}
                                alt="App Store"
                                style={{
                                    width: !isMobile ? '180px' : '120px',
                                    height: 'auto',
                                    cursor: 'pointer',
                                }}
                            />
                        </a>
                    </Box>

                    <Typography mt={1} textAlign={isMobile ? "justify" : "center"} fontSize={12}>
                        Presiona sobre los botones de Google Play o App Store para descargar la aplicación.
                    </Typography>*
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center" }}>
          <Button
            onClick={handleCloseAviso}
            style={{
              backgroundColor: "#ed3434",
              border: "none",
              color: "#fff",
            }}
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog> */}

      <section id="inicio">
        <div className="hero_area">
          {/* header section starts */}
          <header className="header_section">
            <div className="container-fluid">
              <nav className="navbar navbar-expand-lg custom_nav-container">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Lottie
                    loop
                    animationData={mouseAnimation}
                    play
                    style={{
                      width: isMobile ? "30px" : "50px",
                      height: "auto",
                    }}
                  />
                  <a className="navbar-brand" href="#">
                    <div className="brand_text">
                      <img
                        src={LogoDigital}
                        alt="Logo Digital"
                        style={{
                          width: isMobile ? "150px" : "250px",
                          height: "auto",
                          marginLeft: 10,
                        }}
                      />
                    </div>
                  </a>
                </div>

                <button
                  className="navbar-toggler"
                  type="button"
                  data-toggle="collapse"
                  data-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className=""> </span>
                </button>
                <div
                  className="collapse navbar-collapse"
                  id="navbarSupportedContent"
                >
                  <ul className="navbar-nav">
                    <li className="nav-item">
                      <a className="nav-link" href="#inicio">
                        <b>Inicio</b>
                        <span className="sr-only">(current)</span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#que-es-injuemp-conecta">
                        <b>¿Qué es INJUPEMP Conectados?</b>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#servicios-disponibles">
                        <b>Servicios</b>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#crear-usuario">
                        <b>Crear Usuario</b>
                      </a>
                    </li>
                    {isMobile2 && (
                      <li className="nav-item">
                        <Link to="/Login" className="nav-link">
                          <b>Iniciar Sesión</b>
                        </Link>
                      </li>
                    )}
                  </ul>
                  <div className="quote_btn-container">
                    <Link to="/Login" className="quote_btn">
                      Iniciar Sesión
                    </Link>
                  </div>
                </div>
              </nav>
            </div>
          </header>
          {/* end header section */}

          {
            <Tooltip
              title="Ir al ChatBot INJUPEMP Virtual"
              placement="left"
              arrow
            >
              <a
                href="https://wa.link/kbcxjr"
                className="btn-wsp"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaWhatsapp className="icono" />
              </a>
            </Tooltip>
          }

          {/* slider section */}
          <section className="slider_section">
            <div
              id="customCarousel1"
              className="carousel slide"
              data-ride="carousel"
            >
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="img-box">
                          <Lottie
                            loop
                            animationData={animation}
                            play
                            style={{ width: "80%", height: "auto" }} // Ajusta el estilo según tus necesidades
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="detail-box">
                          {/*<h1 style={{marginTop: 10}}>INJUPEMP Conectados</h1>*/}
                          <p
                            style={{
                              marginTop: 10,
                              textAlign: "justify",
                              fontSize: 25,
                            }}
                          >
                            <b>INJUPEMP Conectados</b>, nuestro portal digital
                            para las personas afiliadas de nuestras
                            instituciones a las que damos protección y previsión
                            social.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="carousel-item">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="img-box">
                          <Lottie
                            loop
                            animationData={animation3}
                            play
                            style={{ width: "100%", height: "auto" }} // Ajusta el estilo según tus necesidades
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="detail-box">
                          <h1>CONECTADOS</h1>
                          <p style={{ textAlign: "justify", fontSize: 25 }}>
                            Nuestra plataforma está diseñada pensando en su
                            comodidad, permitiéndole realizar trámites
                            electrónicos de forma segura y sin complicaciones.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="carousel-item">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="img-box">
                          <Lottie
                            loop
                            animationData={animation2}
                            play
                            style={{ width: "100%", height: "auto" }} // Ajusta el estilo según tus necesidades
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="detail-box">
                          <h1>INNOVANDO</h1>
                          <p
                            style={{
                              marginTop: 10,
                              textAlign: "justify",
                              fontSize: 25,
                            }}
                          >
                            ¡Empiece hoy mismo a disfrutar de la experiencia
                            digital que le merecen!
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ol className="carousel-indicators">
                <li
                  data-target="#customCarousel1"
                  data-slide-to="0"
                  className="active"
                ></li>
                <li data-target="#customCarousel1" data-slide-to="1"></li>
                <li data-target="#customCarousel1" data-slide-to="2"></li>
              </ol>
            </div>
          </section>
          {/* end slider section */}
        </div>

        {/* service section */}
        <section id="crear-usuario">
          <section className="service_section layout_padding">
            <div className="container">
              <div className="heading_container">
                <h2>¿Aún no tiene usuario?</h2>
                <p>
                  Si está afiliado puede solicitar directamente la creación de
                  su usuario electrónico en cuatro sencillos pasos:
                </p>
              </div>
              <div className="row">
                <div className="col-md-6 col-lg-3">
                  <div className="box">
                    <div className="img-box">
                      <img src={s5} alt="" />
                    </div>
                    <div className="detail-box">
                      <h5>1. Verificar afiliación</h5>
                      <p>
                        Ingrese su número de identidad y correo electrónico en
                        los campos proporcionados para verificar su afiliación a
                        INJUPEMP.
                      </p>
                      <a href="#" onClick={handleShow}>
                        <span>Iniciar verificación aquí</span>
                        <i
                          className="fa fa-long-arrow-right"
                          aria-hidden="true"
                        ></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="box">
                    <div className="img-box">
                      <img src={s4} alt="" />
                    </div>
                    <div className="detail-box">
                      <h5>2. Recepción de código de seguridad</h5>
                      <p>
                        Se enviará un código de seguridad de 6 dígitos al correo
                        electrónico proporcionado en su afiliación (verificar
                        carpeta spam).
                      </p>
                      <br></br>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="box">
                    <div className="img-box">
                      <img src={s6} alt="" />
                    </div>
                    <div className="detail-box">
                      <h5>3. Ingreso del código de seguridad</h5>
                      <p>
                        Introducir el código de seguridad que ha recibido por
                        correo electrónico para continuar con el proceso.
                      </p>
                      <br></br>
                      <br></br>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="box">
                    <div className="img-box">
                      <img src={s3} alt="" />
                    </div>
                    <div className="detail-box">
                      <h5>4. Lectura y aceptación del contrato</h5>
                      <p>
                        Lea detenidamente el Contrato de Servicios Electrónicos
                        y acepte los términos para finalizar su registro.
                      </p>
                      <br></br>
                      <br></br>
                    </div>
                  </div>
                </div>
              </div>
              <div className="btn-box">
                <Link to="/Login" className="quote_btn">
                  ¿Tiene ya acceso? Conéctese aquí
                </Link>
              </div>
            </div>
          </section>
        </section>
        {/* end service section */}

        <section
          className="about_section"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={injupemplogogobierno}
            alt="Logo Digital"
            style={{
              width: isMobile ? "250px" : "350px",
              height: "auto",
              marginTop: 30,
              marginBottom: 20,
            }}
          />
        </section>

        {/* SERVICIOS DISPONIBLES */}
        <section id="servicios-disponibles">
          <section className="service_section layout_padding">
            <div className="container">
              <div className="heading_container">
                <h2>Servicios Disponibles</h2>
                <p>
                  Realiza tus trámites de forma 100% en línea desde cualquier
                  lugar, ya sea tu hogar o lugar de trabajo, sin necesidad de
                  trasladarte a nuestras oficinas:
                </p>
              </div>
              <div className="row justify-content-center">
                <div className="col-md-6 col-lg-3">
                  <div className="box">
                    <div className="img-box">
                      <img src={prestamo} alt="" />
                    </div>
                    <div className="detail-box">
                      <h5>Solicitud de Preanálisis de Préstamo</h5>
                      <p>
                        Descubre tu monto a otorgar solicitando tus preanálisis
                        de préstamos personales e hipotecarios adjuntando la
                        documentación requerida.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="box">
                    <div className="img-box">
                      <img src={documento} alt="" />
                    </div>
                    <div className="detail-box">
                      <h5>Constancia de Pensionado</h5>
                      <p>
                        Descarga tu constancia de pensionado fácilmente, sin
                        complicaciones, desde nuestro portal en tan solo un
                        clic.
                      </p>
                      <br></br>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="box">
                    <div className="img-box">
                      <img src={ahorro} alt="" />
                    </div>
                    <div className="detail-box">
                      <h5>Visualizar Saldo de Cotizaciones</h5>
                      <p>
                        Visualiza tu saldo cotizado, promedio de salarios
                        cotizados, pensión aproximada y tus últimos salarios
                        cotizados.
                      </p>
                      <br></br>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="box">
                    <div className="img-box">
                      <img src={hombre} alt="" />
                    </div>
                    <div className="detail-box">
                      <h5>Envío de Quejas y Sugerencias</h5>
                      <p>
                        Ayúdanos a seguir mejorando al compartir tus quejas o
                        sugerencias sobre los servicios del INJUPEMP.
                      </p>
                      <br></br>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </section>
        {/* Fin Servicios Disponibles */}

        {/* about section */}
        <section id="que-es-injuemp-conecta">
          <section className="about_section layout_padding">
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                  <div className="detail-box">
                    <div className="heading_container">
                      <h2>
                        El futuro de nuestra institución es INJUPEMP Conectados
                      </h2>
                    </div>
                    <p>
                      Abrimos un mundo completo de servicios y de gestiones para
                      ser más cércanos, más rápidos y ágiles para nuestros
                      afiliados, jubilados e instituciones.
                      <br />
                      <br />{" "}
                      <b>
                        Conéctese y conozca todas las nuevas posibilidades,
                        trámites y servicios que le ofreceremos desde INJUPEMP y
                        que vamos a incorporar en breve.
                        <br />
                        <br /> Estar protegido por INJUPEMP es estar conectado a
                        todos sus derechos y beneficios.
                      </b>
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="img-box">
                    <Lottie
                      loop
                      animationData={digital}
                      play
                      style={{
                        width: !isMobile ? "110%" : "100%",
                        height: "auto",
                        marginLeft: !isMobile ? 40 : 0,
                      }} // Ajusta el estilo según tus necesidades
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </section>
        {/* end about section */}

        {/* client section */}
        <section className="client_section" style={{ marginTop: 20 }}>
          {/*<div className="container">
                    <div className="heading_container heading_center">
                        <h2>
                            Mensaje de nuestra Presidenta
                        </h2>
                    </div>
                </div>*/}
          <div
            id="customCarousel2"
            className="carousel slide"
            data-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item active">
                <div className="container">
                  <div className="row">
                    <div className="col-md-10 mx-auto">
                      <div className="box">
                        {/* <div className="img-box">
                          <img src={logoinjupemp} alt="" />
                        </div> */}
                        <div className="detail-box">
                          <div className="client_info">
                            <div className="client_name">
                              <h5>
                                INSTITUTO NACIONAL DE JUBILACIONES Y PENSIONES
                                DE LOS EMPLEADOS Y FUNCIONARIOS DEL PODER
                                EJECUTIVO
                              </h5>
                              <h6>INJUPEMP</h6>
                            </div>
                            {/*<i className="fa fa-quote-left" aria-hidden="true"></i>*/}
                          </div>
                          <p>
                            INJUPEMP impulsa la transformación digital para
                            ofrecer servicios de previsión social más ágiles y
                            transparentes. Con esta modernización, buscamos
                            mejorar la calidad de vida de los participantes,
                            optimizando procesos y garantizando que cada
                            beneficio llegue de manera justa y oportuna. Nuestro
                            compromiso es construir un país más inclusivo y
                            preparado para los desafíos del futuro.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/*<div className="carousel-item">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-10 mx-auto">
                                        <div className="box">
                                            <div className="img-box">
                                                <img src={client3} alt="" />
                                            </div>
                                            <div className="detail-box">
                                                <div className="client_info">
                                                    <div className="client_name">
                                                        <h5>
                                                            Ing. Mario Suazo
                                                        </h5>
                                                        <h6>
                                                            Sub-Director
                                                        </h6>
                                                    </div>
                                                    <i className="fa fa-quote-left" aria-hidden="true"></i>
                                                </div>
                                                <p>
                                                    "En INJUPEMP, innovamos y trabajamos día a día para mejorar nuestros servicios, actividades y beneficios. La apuesta digital nos hace más cercanos y refuerza nuestros compromisos con nuestros participantes, jubilados e instituciones”.
                                                    <br></br>
                                                    <br></br>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>*/}
            </div>
            <ol
              className="carousel-indicators"
              style={{ visibility: "hidden" }}
            >
              <li
                data-target="#customCarousel2"
                data-slide-to="0"
                className="active"
              ></li>
              <li data-target="#customCarousel2" data-slide-to="1"></li>
            </ol>
          </div>
        </section>
        {/* end client section */}

        <div className="footer_container">
          <section className="info_section">
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-lg-3">
                  <div className="info_detail">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <h4 style={{ marginBottom: "10px" }}>
                        INJUPEMP Conectados
                      </h4>
                      <Lottie
                        loop
                        animationData={mouseAnimation}
                        play
                        style={{
                          width: isMobile ? "30px" : "50px",
                          height: "auto",
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-2 mx-auto">
                  <div className="info_link_box">
                    <h4>Links</h4>
                    <div className="info_links">
                      <a className="" href="#">
                        Inicio
                      </a>
                      <a className="" href="#que-es-injuemp-conecta">
                        ¿Qué es INJUPEMP Conectados?
                      </a>
                      <a className="" href="#servicios-disponibles">
                        Servicios
                      </a>
                      <a className="" href="#crear-usuario">
                        Crear Usuario
                      </a>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-lg-3 mb-0 ml-auto">
                  <div className="info_contact">
                    <h4>Contacto y Soporte</h4>
                    <div className="contact_link_box">
                      <a
                        href="https://maps.app.goo.gl/pmvUaL48qTr24pPY6"
                        target="_blank"
                      >
                        <i className="fa-solid fa-location-dot"></i>
                        <span>
                          Loma Linda Norte, Ave La FAO, Tegucigalpa D.C.
                        </span>
                      </a>
                      <a href="tel:+50422901900">
                        <i className="fa fa-phone" aria-hidden="true"></i>
                        <span>+504 2290-1900</span>
                      </a>
                      <a href="mailto:info@injupemp.gob.hn">
                        <i className="fa fa-envelope" aria-hidden="true"></i>
                        <span>info@injupemp.gob.hn</span>
                      </a>
                    </div>
                  </div>
                  <div className="info_social">
                    <a
                      href="https://www.facebook.com/injupemp/"
                      target="_blank"
                    >
                      <i
                        className="fa-brands fa-facebook"
                        aria-hidden="true"
                      ></i>
                    </a>
                    <a href="https://x.com/injupemp?lang=en" target="_blank">
                      <i
                        className="fa-brands fa-x-twitter"
                        aria-hidden="true"
                      ></i>
                    </a>
                    <a
                      href="https://www.youtube.com/@injupemphonduras1770"
                      target="_blank"
                    >
                      <i
                        className="fa-brands fa-youtube"
                        aria-hidden="true"
                      ></i>
                    </a>
                    <a
                      href="https://www.instagram.com/injupempHn/?hl=en"
                      target="_blank"
                    >
                      <i
                        className="fa-brands fa-instagram"
                        aria-hidden="true"
                      ></i>
                    </a>
                    {
                      <a href="https://wa.link/kbcxjr" target="_blank">
                        <i
                          className="fa-brands fa-whatsapp"
                          aria-hidden="true"
                        ></i>
                      </a>
                    }
                  </div>
                </div>
              </div>
            </div>
          </section>

          <footer className="footer_section">
            <div className="container">
              <p>
                <a href="https://www.injupemp.gob.hn/">INJUPEMP</a>
                &copy; <span id="displayYear"></span> Todos los derechos
                reservados
              </p>
            </div>
          </footer>
        </div>

        <script src="js/jquery-3.4.1.min.js"></script>
        <script
          src="https://cdn.jsdelivr.net/npm/popper.js@1.16.0/dist/umd/popper.min.js"
          integrity="sha384-Q6E9RHvbIyZFJoft+2mJbHaEWldlvI9IOYy5n3zV9zzTtmI3UksdQRVvoxMfooAo"
          crossOrigin="anonymous"
        ></script>
        <script src="js/bootstrap.js"></script>
        <script src="js/custom.js"></script>
        <script
          src={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ""}`}
          async
        ></script>
        <script src="js/scrolling-nav.js"></script>

        <Modal
          show={showResultModal}
          onHide={handleClose}
          dialogClassName="custom-modal"
        >
          <Modal.Header
            closeButton={false}
            className="d-flex justify-content-between align-items-center"
          >
            <Modal.Title>Resultado de la verificación</Modal.Title>
            <Button
              className="close"
              onClick={handleClose}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                backgroundColor: "transparent",
                border: "none",
              }}
            >
              <i className="fas fa-times" aria-hidden="true"></i>
            </Button>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex align-items-center">
              <i
                className={`fas ${
                  resultType === "error" ? "fa-times-circle" : "fa-check-circle"
                } fa-2x mr-2 ${
                  resultType === "error" ? "text-danger" : "text-success"
                }`}
              ></i>
              <p className="mb-0 text-dark">{resultMessage}</p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {/* Condición para mostrar el nuevo botón */}
            {showChangeEmailButton && (
              <Button
                variant="primary"
                onClick={handleChangeEmailClick}
                style={{
                  backgroundColor: "#19438C",
                  borderColor: "#19438C",
                  color: "#fff",
                  marginRight: 10,
                  fontWeight: "bold",
                }}
              >
                Solicitar Cambio De Correo
              </Button>
            )}
            <Button variant="secondary" onClick={handleClose}>
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>

        {/* El modal para verificación de datos sigue igual */}
        <Modal
          show={showModal}
          onHide={handleClose}
          dialogClassName="custom-modal"
        >
          <Modal.Header
            closeButton={false}
            className="d-flex justify-content-between align-items-center"
          >
            <Modal.Title>Verificación de Datos</Modal.Title>
            <Button
              className="close"
              onClick={handleClose}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                backgroundColor: "transparent",
                border: "none",
              }}
            >
              <i className="fas fa-times" aria-hidden="true"></i>
            </Button>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group controlId="formBasicPassword">
                <Form.Label>Número de Identidad</Form.Label>
                <Form.Control
                  type="tel"
                  inputMode="numeric"
                  placeholder="####-####-#####"
                  value={dni}
                  maxLength={15}
                  style={{ width: isMobile ? 280 : 400 }}
                  onChange={(e) => {
                    setDni(formatDni(e.target.value));
                  }}
                  required
                />
              </Form.Group>

              <Form.Group controlId="formBasicEmail">
                <Form.Label style={{ marginTop: 15 }}>
                  Correo Electrónico
                </Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Introduce tu correo electrónico"
                  value={correo}
                  style={{ width: isMobile ? 280 : 400 }}
                  onChange={(e) => setCorreo(e.target.value)}
                  required
                />
              </Form.Group>

              {/* Mostrar mensaje de error si existe */}
              {errorMessage2 && (
                <Alert
                  severity="error"
                  style={{
                    marginTop: "10px",
                    width: isMobile ? 280 : 400,
                    marginTop: 15,
                  }}
                >
                  {errorMessage2}
                </Alert>
              )}

              <div
                className="d-flex justify-content-center"
                style={{ marginTop: 20 }}
              >
                <Button
                  variant="primary"
                  type="submit"
                  style={{
                    backgroundColor: "#19438C",
                    borderColor: "#19438C",
                    color: "#fff",
                    marginRight: 10,
                    fontWeight: "bold",
                  }}
                  disabled={loading}
                  onClick={handleVerify}
                >
                  {loading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        style={{ color: "#fff" }}
                      />
                      &nbsp;Verificando...
                    </>
                  ) : (
                    "Verificar"
                  )}
                </Button>
                <Button
                  variant="secondary"
                  onClick={handleClose}
                  style={{
                    backgroundColor: "#6c757d",
                    borderColor: "#6c757d",
                    color: "#fff",
                  }}
                >
                  Cerrar
                </Button>
              </div>
            </Form>
          </Modal.Body>
        </Modal>

        {/* El modal para el código de 4 dígitos */}
        <Modal
          show={showModalCodigo}
          onHide={handleCloseCodigo}
          dialogClassName="custom-modal"
        >
          <Modal.Header
            closeButton={false}
            className="d-flex justify-content-between align-items-center"
          >
            <Modal.Title>Código de verificación</Modal.Title>
            <Button
              className="close"
              onClick={handleCloseCodigo}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                backgroundColor: "transparent",
                border: "none",
              }}
            >
              <i className="fas fa-times" aria-hidden="true"></i>
            </Button>
          </Modal.Header>
          <Modal.Body>
            <p>
              Ingrese el código de 6 dígitos enviado al correo electrónico
              proporcionado.
            </p>
            <p>
              <b>Nota:</b> El código tiene una duración de 15 minutos. Si sales
              de esta ventana el código expirará.
            </p>
            <Form onSubmit={handleContrato}>
              <Form.Group controlId="formVerificationCode">
                <Form.Control
                  type="text"
                  inputMode="numeric"
                  placeholder="Ingrese el código de 6 dígitos"
                  value={verificationCode}
                  style={{ width: isMobile ? 280 : 400 }}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Permitir solo números y hasta 4 dígitos
                    if (/^\d{0,6}$/.test(value)) {
                      setVerificationCode(value);
                    }
                  }}
                  required
                />
              </Form.Group>
              <div
                style={{
                  textAlign: "center",
                  fontSize: "18px",
                  fontWeight: "bold",
                  marginBottom: "20px",
                  marginTop: 10,
                }}
              >
                Tiempo restante: {formatTime(timeLeft)}
              </div>

              {/* Muestra el mensaje de error si existe */}
              {errorMessage && (
                <Alert severity="error" style={{ marginTop: "10px" }}>
                  {errorMessage}
                </Alert>
              )}

              <div
                className="d-flex justify-content-center"
                style={{ marginTop: 5 }}
              >
                <Button
                  variant="primary"
                  type="submit"
                  style={{
                    backgroundColor: "#19438C",
                    borderColor: "#19438C",
                    color: "#fff",
                    fontWeight: "bold",
                  }}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        style={{ color: "#fff" }}
                      />
                      &nbsp;Enviando...
                    </>
                  ) : (
                    "Validar Código"
                  )}
                </Button>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      </section>
    </>
  );
};

export default PaginaInicioPortal;
